package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.CharacterSheet
import fr.manyverse.app.domain.model.PreMadeCharacter
import fr.manyverse.app.domain.model.PreMadeCharacterToUpdate
import fr.manyverse.app.domain.model.PreMadeInventoryItem
import fr.manyverse.app.domain.repository.PreMadeCharacterRepository
import fr.manyverse.app.domain.validation.CharacterSheetValidator
import fr.manyverse.app.domain.validation.CharacterValidator

class UpdatePreMadeCharacterUseCase(
    private val preMadeCharacterRepository: PreMadeCharacterRepository
) {
    suspend operator fun invoke(
        id: String,
        name: String,
        story: String,
        imageUrl: String? = null,
        sheet: CharacterSheet = CharacterSheet(),
        inventory: List<PreMadeInventoryItem> = emptyList()
    ): Result<PreMadeCharacter> {
        CharacterValidator.validateForUpdate(
            characterId = id,
            name = name
        ).onFailure { return Result.failure(it) }

        sheet.gauges.forEach { gauge ->
            CharacterSheetValidator
                .validateGauge(gauge.label, gauge.min, gauge.max, gauge.increment, gauge.current)
                .onFailure { return Result.failure(it) }
        }
        sheet.characteristics.forEach { char ->
            CharacterSheetValidator.validateCharacteristic(char.label, char.value, char.description)
                .onFailure { return Result.failure(it) }
        }
        sheet.skills.forEach { skill ->
            CharacterSheetValidator.validateSkill(skill.label, skill.description)
                .onFailure { return Result.failure(it) }
        }
        sheet.powers.forEach { power ->
            CharacterSheetValidator.validatePower(power.label, power.description)
                .onFailure { return Result.failure(it) }
        }

        val update = PreMadeCharacterToUpdate(
            name = name,
            story = story,
            imageUrl = imageUrl,
            sheet = sheet,
            inventory = inventory
        )

        return preMadeCharacterRepository.updatePreMadeCharacter(id, update)
    }
}
